@if (headerService.menuOpened()) {
	<div
		class="fixed md:hidden top-0 left-0 w-screen h-screen bg-white/60 z-[98]"
		(click)="headerService.closeMenu()"
		tabindex="0"
		(keyup.space)="headerService.closeMenu()"
	></div>
}

<div
	class="fixed md:static -right-[88px] md:left-0 top-0 md:top-[70px] flex flex-col h-full pt-3 md:pt-8 px-5 z-[99] bg-primary-100 text-white transition-all overflow-hidden max-w-[260px] md:rounded-tr-3xl"
	[ngClass]="{
		'w-[260px] !right-0 pr-0': headerService.menuOpened() && menuMode() !== 'Extended',
		'w-[340px] max-w-[340px] !right-0 pr-0': headerService.menuOpened() && menuMode() === 'Extended',
		'w-[88px]': !headerService.menuOpened(),
	}"
>
	<div class="flex flex-col gap-4 pb-8 pr-3 md:pr-0 w-full h-full justify-center">
		<div
			class="flex md:hidden gap-2 items-center p-2 rounded-xl hover:bg-primary-140 cursor-pointer ml-auto w-12 h-12"
			(click)="headerService.closeMenu()"
		>
			<app-svg-asset name="icons/basic/x" class="w-8 ml-auto" />
		</div>

		<a href="/" class="max-h-full">
			<app-svg-asset
				name="gb-logo"
				class="size-auto hidden -ml-2"
				[ngClass]="{
					'md:block': headerService.menuOpened(),
				}"
			/>
			<app-svg-asset
				name="gb-logo-small"
				class="size-auto hidden md:block"
				[ngClass]="{
					'md:hidden': headerService.menuOpened(),
				}"
			/>
			<app-svg-asset name="gb-logo-large" class="size-auto block w-fit ml-2.5 mb-4 md:hidden" />
		</a>

		<app-admin-profile />

		@let menuOpened = headerService.menuOpened();
		@for (navLink of navLinks; track $index) {
			@let link = navLink.link;
			@let icon = navLink.icon;
			@let title = navLink.title;
			<a
				*appPrivilegeGuard="navLink.privileges"
				class="flex gap-2 items-center p-2 hover:bg-primary-140 text-white cursor-pointer w-full h-12 select-none"
				[class.rounded-l-xl]="menuOpened"
				[class.rounded-xl]="!menuOpened"
				[routerLink]="link"
				[routerLinkActive]="['bg-white', '!text-primary-140', 'hover:bg-white']"
			>
				<app-svg-asset [name]="icon" [ds]="navLink.dsIcon ?? true" class="w-8" />
				<span
					class="text-base font-semibold overflow-hidden transition-opacity duration-200 ease-in-out"
					[class.opacity-100]="menuOpened"
					[class.opacity-0]="!menuOpened"
					[class.pointer-events-none]="!menuOpened"
				>
					{{ title | translate }}
				</span>
			</a>
		}

		<div class="flex flex-col h-full justify-end">
			<a
				class="flex gap-2 items-center p-2 hover:bg-primary-140 cursor-pointer w-full h-12"
				[ngClass]="roundedMenuItemClass()"
				(click)="logout()"
			>
				<app-svg-asset name="icons/action/logout" class="w-8" />
				<span
					class="text-base font-semibold overflow-hidden transition-opacity duration-200 ease-in-out"
					[ngClass]="{
						'opacity-100': headerService.menuOpened(),
						'opacity-0 pointer-events-none': !headerService.menuOpened(),
					}"
				>
					{{ 'admin.logout.title' | translate }}
				</span>
			</a>
			<div
				class="hidden md:flex gap-2 self-end items-center hover:bg-primary-140 duration-200 ease p-2 cursor-pointer w-fit h-12"
				[ngClass]="roundedMenuItemClass()"
				(click)="toggleSideMenu()"
			>
				@if (headerService.menuOpened()) {
					<app-svg-asset name="icons/direction/left" class="w-8 ml-auto" />
				} @else {
					<app-svg-asset name="icons/direction/right" class="w-8" />
				}
			</div>
		</div>
	</div>
</div>
